module.exports = __webpack_public_path__ + "static/media/choithramsAccountB.3c75f549.png";